module.exports = __webpack_public_path__ + "static/img/success.c4eb268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/success.png
// module id = I59q
// module chunks = 1